import { useCallback, useMemo, useSyncExternalStore } from "react";
import type { LocalizedText } from "../registration/layoutHandles.ts";

export function useLocalizedText({ instance, namespace, resourceKey }: LocalizedText): string {
    const subscribe = useCallback(
        (onLanguageChange: () => void) => {
            instance.on("languageChanged", onLanguageChange);

            return () => {
                instance.off("languageChanged", onLanguageChange);
            };
        },
        [instance]
    );

    const language = useSyncExternalStore(subscribe, () => instance.language);

    return useMemo(() => instance.getFixedT(language, namespace)(resourceKey), [instance, language, namespace, resourceKey]);
}
